'use client'
import { useState } from 'react'

import { useCopyText } from '../../../generic-hooks'

import { type FeedbackState } from './types'

const COPY_SUCCESS_DURATION = 3000

type UseProductCopyVoucherButtonControls = (options: { voucher: string }) => {
  copyVoucher: () => void
  feedbackState: FeedbackState
}

export const useProductCopyVoucherButtonControls: UseProductCopyVoucherButtonControls =
  ({ voucher }) => {
    const { copyText } = useCopyText(voucher)

    const [feedbackState, setFeedbackState] = useState<FeedbackState>('idle')

    const copyVoucher = (): void => {
      if (feedbackState === 'copySuccess') {
        return
      }

      void copyText()

      setFeedbackState('copySuccess')

      setTimeout(() => {
        setFeedbackState('idle')
      }, COPY_SUCCESS_DURATION)
    }

    return {
      copyVoucher,
      feedbackState,
    }
  }
